export default "__VITE_ASSET__Cebfxfxq__"